import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Grid,
} from "@mui/material";
import { FaShareAlt, FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaEnvelope, FaLink, FaEllipsisH } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";

export default function ShareDialog({ productName }) {
  const [open, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  // Native Mobile Share
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: productName,
          text: `Check out this product: ${productName}`,
          url: currentUrl,
        });
      } catch (error) {
        console.log("Share canceled or failed:", error);
      }
    } else {
      alert("Native sharing is not supported on this device. Use the buttons below.");
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    // alert("Link copied to clipboard!");
  };

  return (
    <>
      {/* Share button */}
      <Button
        startIcon={<FaShareAlt />}
        variant="text"
        onClick={() => setOpen(true)}
      >
        Share
      </Button>
      {/* <FaShareAlt
        onClick={() => setOpen(true)}
      /> */}

      {/* Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Share {productName}
          <IconButton onClick={() => setOpen(false)}>
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
           

            {/* WhatsApp */}
            <Grid item>
              <WhatsappShareButton url={currentUrl} title={productName}>
                <FaWhatsapp size={32} color="#25D366" />
              </WhatsappShareButton>
            </Grid>

            {/* Facebook */}
            <Grid item>
              <FacebookShareButton url={currentUrl} quote={productName}>
                <FaFacebook size={32} color="#1877F2" />
              </FacebookShareButton>
            </Grid>

            {/* Twitter */}
            <Grid item>
              <TwitterShareButton url={currentUrl} title={productName}>
                <FaTwitter size={32} color="#1DA1F2" />
              </TwitterShareButton>
            </Grid>

            {/* LinkedIn */}
            <Grid item>
              <LinkedinShareButton url={currentUrl} title={productName}>
                <FaLinkedin size={32} color="#0A66C2" />
              </LinkedinShareButton>
            </Grid>

            {/* Email */}
            <Grid item>
              <EmailShareButton url={currentUrl} subject={productName}>
                <FaEnvelope size={32} color="#D44638" />
              </EmailShareButton>
            </Grid>

            {/* Copy Link */}
            <Grid item>
              <IconButton onClick={handleCopyLink} title="Copy Link">
                <FaLink size={32} />
              </IconButton>
            </Grid>
             {/* Mobile Native Share */}
             <Grid item>
              <IconButton onClick={handleNativeShare} title="More options">
                <FaEllipsisH size={32} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
